// extracted by mini-css-extract-plugin
export default {"message__cover":"styles_message__cover__ZnLwP","message__title":"styles_message__title__aov5A","message__text":"styles_message__text__Zsoj5"};